import styled from "@emotion/styled";

export const AISparkleLoader = () => {
  return (
    <Loader className='loader'>
      <svg viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          className='big-star'
          d='M21.5999 9.1001C22.0274 14.6572 26.4428 19.0727 32 19.5001C26.4428 19.9275 22.0274 24.343 21.5999 29.9001C21.1725 24.343 16.7571 19.9275 11.2 19.5001C16.7571 19.0727 21.1725 14.6572 21.5999 9.1001Z'
          fill='#727DF9'
        />
        <path
          className='small-star'
          d='M10.4 6.8999C10.6302 9.89219 13.0078 12.2698 16 12.4999C13.0078 12.73 10.6302 15.1076 10.4 18.0999C10.1699 15.1076 7.79234 12.73 4.80005 12.4999C7.79234 12.2698 10.1699 9.89219 10.4 6.8999Z'
          fill='#D1D5DB'
        />
      </svg>
    </Loader>
  );
};

const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 32px;
    height: 32px;
    filter: drop-shadow(0 0 10px #727df944);
  }

  .big-star {
    animation: bigPulse 1s ease-in-out infinite;
    transform-origin: 21.6px 19.5px;
  }

  .small-star {
    animation: smallPulse 1s ease-in-out infinite;
    animation-delay: 0.5s;
    transform-origin: 10.4px 12.5px;
  }

  @keyframes bigPulse {
    0%,
    100% {
      transform: scale(1);
    }
    50% {
      transform: scale(0.5);
    }
  }

  @keyframes smallPulse {
    0%,
    100% {
      transform: scale(1.5);
    }
    50% {
      transform: scale(1);
    }
  }
`;
